/*
    模块组件
    ChenYN

    说明
    规则弹窗

    版本
    1.0

    传参
        show Boolean : 必填 显示规则弹窗
        rule Object ： 必填 规则弹窗的内容
            rule : {
                title String : 必填 规则弹窗的标题
                content String : 必填 规则
            }
        close Function : 非必填 关闭弹窗
    依赖
    /style/2019/h5/css/common.css
    vue.js

    案例
    <demo></demo>
*/
<template>
    <Popup :show="show" class="rule_popup" teleport="#app" @closed="closePop">
        <div class="rule_pop">
            <div class="title">{{rule.title}}</div>
            <Icon class="close_btn" name="cross" @click="closePop"/>

            <pre class="content cancel_scroll_bar" v-html="rule.content"></pre>
        </div>
    </Popup>
</template>

<script lang="js">
import { defineComponent, reactive, toRefs, onMounted, } from 'vue';
import { Popup, Icon  } from "vant"
import router from "@/router"

export default defineComponent({
    name: 'RulePopup',
    components: { Popup, Icon  },
    props: {
        show: {
            type: Boolean,
            default: false
        },
        rule: {
            type: Object,
            default: {
                title: '',
                content: ''
            }
        },
        close: {
            type: Function,
        },
    },
    setup(props) {
        const state = reactive({});
        const data = reactive({});
        const methods = {
            back: () => route.back(),
            goState: (o) => router.push(o),
            closePop: () => {
                if(props.close){
                    props.close();
                }
            }
        }; //需要对外暴露的方法

        return {
            ...toRefs(state),
            ...toRefs(data),
            ...methods
        };
    },
});
</script>
<style lang="less" scoped>
@charset "utf-8";
@import "./RulePopup.less";
</style>